module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/169-liberia-dadb85b3f562609eafde157efa0aa0f4.svg";